import React from 'react';
import PropTypes from 'prop-types';
// components
import { Loader } from 'semantic-ui-react';
// stylesheets
import styles from './Loading.module.scss';

function Loading(props) {
  const { inline, isLoading, message, size } = props;

  return (
    isLoading && (
      <Loader inline={inline} active className={styles.loader} size={size}>
        {message}
      </Loader>
    )
  );
}

Loading.defaultProps = {
  message: '',
  isLoading: true,
  inline: false,
  size: 'big'
};

Loading.propTypes = {
  inline: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  size: PropTypes.oneOf('mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive')
};

export default Loading;
